import { render, staticRenderFns } from "./batch_transfer.vue?vue&type=template&id=5a4409ca&scoped=true&"
import script from "./batch_transfer.vue?vue&type=script&lang=js&"
export * from "./batch_transfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4409ca",
  null
  
)

export default component.exports